
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"300","height":"110","viewBox":"0 0 79.375 29.104","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a","clipPathUnits":"userSpaceOnUse"}})]),_c('path',{attrs:{"d":"M65.364 10.67l-.009 5.489-.008 5.488 5.826-2.738 5.826-2.738-5.817-2.75z"}}),_c('path',{attrs:{"transform":"matrix(.78294 0 0 .78294 -64.26 -148.442)","clip-path":"url(#a)","d":"M65.579 116.795h98.84v66.901H65.58z","fill":"none"}}),_c('path',{attrs:{"d":"M37.486 5.592c-2.048-.006-4.129.094-5.182.295-3.173.601-6.756 4.828-6.756 4.828-.348 0-2.38.137-3.855.24-.885.063-1.633.466-1.743 1.247l-.604 5.6c0 1.377.604 1.479 1.072 1.562.419.08 2.197.216 2.598.246-.002-.05-.004-.1-.004-.152a4.87 4.87 0 014.872-4.867 4.873 4.873 0 014.879 4.867c0 .055-.003.11-.004.164l14.717-.001c0-.034-.005-.068-.005-.102a4.87 4.87 0 014.873-4.867 4.873 4.873 0 014.878 4.867c0 .023-.003.045-.003.068.918-.024 1.864-.065 1.952-.13.299-.218.814-1.487.804-1.935-.036-1.538-.838-3.24-1.864-4.038-1.646-1.28-3.068-1.895-7.946-2.537 0 0-5.27-4.422-7.692-5.014-.924-.224-2.94-.336-4.987-.341z"}}),_c('path',{attrs:{"d":"M23.828 19.448a4.064 4.064 0 108.126 0 4.06 4.06 0 00-4.065-4.056 4.059 4.059 0 00-4.06 4.056zM48.368 19.448a4.064 4.064 0 108.126 0 4.06 4.06 0 00-4.065-4.056 4.059 4.059 0 00-4.06 4.056z"}})])
          )
        }
      }
    